export default __webpack_public_path__ + "static/video-logo-c3612c7ab819e5997c145e9e31222f7e.svg";